import template from './jobEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $mdDialog,
      $mdMedia,
      eventService,
      jobService,
      jobTypeService,
      contactService,
      contactsService,
      ticketService,
      ticketsService,
      workflowService,
      workflowsService,
      dateTimeService,
      searchService,
      uiService,
      Job,
      JobType,
      JobItem,
      JobProgress,
      TimeUnit,
      Ticket,
      Contact,
      CONTACT,
      TICKET
    ) {
      'ngInject';

      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = null;
      ctrl.currentCurrency = null;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.$mdDialog = $mdDialog;
      ctrl.mdMedia = $mdMedia;
      ctrl.destroyWatch = null;
      ctrl.availableWorkflows = [];

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {
        ctrl.destroyWatch = eventService.onJobEdit((params) => {
          let currentJob = null;
          if (params.job) {
            currentJob = angular.copy(params.job);
          } else {
            currentJob = Job.blank();
          }
          if (currentJob !== null) {
            $mdDialog
              .show({
                targetEvent: params.event,
                locals: {
                  job: currentJob,
                  isJob: params.isJob,
                  showAccounts: params.showAccounts,
                  showTicket: params.showTicket,
                  isTasksPage: params.isTasksPage,
                  stage: params.stage,
                  jobTypes: params.jobTypes,
                  accounts: params.accounts,
                  workflow: params.workflow ? params.workflow : null,
                  ticket: params.ticket ? params.ticket : null,
                  contact: params.contact ? params.contact : null,
                  mdMedia: ctrl.mdMedia
                },
                template,
                controllerAs: '$ctrl',
                controller(
                  $state,
                  $timeout,
                  job,
                  isJob,
                  showAccounts,
                  showTicket,
                  isTasksPage,
                  stage,
                  jobTypes,
                  accounts,
                  workflow,
                  ticket,
                  contact,
                  mdMedia
                ) {
                  const ctr = this;
                  ctr.currentOrganization = $rootScope.CurrentOrganization;
                  ctr.currentAccount = $rootScope.CurrentAccount;
                  ctr.currentCurrency = $rootScope.CurrentCurrency();
                  ctr.currentTimeZone = $rootScope.CurrentTimeZone();
                  ctr.currentLocale = $rootScope.CurrentLocale();
                  ctr.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
                  ctr.job = job;

                  ctr.availableRepeats = Job.availableRepeats();
                  ctr.availableDaysOfTheWeek = Job.availableDaysOfTheWeek();
                  ctr.availableEndOptions = Job.availableEndOptions();
                  ctr.availableRepeatEvery = Job.availableRepeatEvery();

                  if (!ctr.job.id) {
                    const date = dateTimeService.setDate(
                      moment.utc().tz(ctr.currentTimeZone).startOf('day'),
                      ctr.currentTimeZone
                    );
                    ctr.job.absoluteDueDate = parseInt(moment.utc(date).format('X') || 0, 10);
                  }
                  dateTimeService.getSet(ctr, ctr.job, 'absoluteDueDate', 'getSetAbsoluteDate');
                  dateTimeService.getSet(
                    ctr,
                    ctr.job,
                    'repeat.duration.startDate',
                    'getSetRepeatStartDate'
                  );
                  dateTimeService.getSet(
                    ctr,
                    ctr.job,
                    'repeat.duration.endDate',
                    'getSetRepeatEndDate'
                  );
                  // Change Absolute Due Date
                  ctr.changeAbsoluteDueDate = () => {
                    const cD = moment.utc().startOf('day');
                    const tD = moment.utc().startOf('day').add(1, 'day');
                    const aD = moment.utc(ctr.job.absoluteDueDate, 'X').startOf('day');
                    ctr.job.isOverdue = !ctr.job.isOverdue && aD.isBefore(cD, 'day');
                    ctr.job.isDue =
                      !ctr.job.isOverdue && !ctr.job.isDue && aD.isSame(cD, 'day');
                    ctr.job.isDueAhead =
                      !ctr.job.isDue && !ctr.job.isDueAhead && aD.isSame(tD, 'day');
                  };

                  ctr.changeAbsoluteDueDate();

                  ctr.isJobDescriptionChanged = false;
                  ctr.isEditingJob = _.isUuid(job.id);

                  ctr.isJob = isJob;
                  ctr.showAccounts = showAccounts;
                  ctr.stage = stage;
                  ctr.isStageJob = ctr.stage !== null ? ctr.stage : false;
                  ctr.jobTypes = jobTypes;
                  ctr.accounts = accounts;
                  ctr.accountsFiltered = ctr.accounts;
                  ctr.workflowsFiltered = workflow !== null ? [workflow] : [];
                  ctr.ticketsFiltered = ticket !== null ? [ticket] : [];
                  ctr.contactsFiltered = contact !== null ? [contact] : [];
                  ctr.contact = {};
                  if (contact !== null) {
                    ctr.contact.avatar = contact.avatar;
                    ctr.contact.isCompany = contact.isCompany;
                    ctr.contact.name = contact.getName();
                    ctr.contact.phone = contact.getPhone();
                    ctr.contact.email = contact.getEmail();
                  } else {
                    ctr.contact.avatar = '';
                    ctr.contact.isCompany = '';
                    ctr.contact.name = '';
                    ctr.contact.phone = '';
                    ctr.contact.email = '';
                  }
                  ctr.showAdditionalOptions = false;
                  if (!ctr.isEditingJob) {
                    ctr.showAdditionalOptions =
                      (ctr.ticketsFiltered.length === 1 &&
                        ctr.workflowsFiltered.length === 1) ||
                      ctr.contactsFiltered.length === 1;
                  } else {
                    ctr.showAdditionalOptions =
                      ctr.job.idTicket !== undefined || ctr.job.idContact !== undefined;
                  }
                  ctr.isWorkflowReady = false;
                  ctr.isTicketReady = false;
                  ctr.isContactReady = false;
                  if (ctr.isEditingJob) {
                    ctr.canSeeAccount = true;
                    if (ctr.currentAccount.isAdministrator) {
                      ctr.canSeeAccount = true;
                    } else if (
                      !ctr.currentAccount.isAdministrator &&
                      (ctr.currentOrganization.permissions.visibilityOtherUsers.team ||
                        ctr.currentOrganization.permissions.visibilityOtherUsers
                          .CurrentOrganization)
                    ) {
                      ctr.canSeeAccount = true;
                    } else if (
                      !ctr.currentAccount.isAdministrator &&
                      ctr.currentOrganization.permissions.visibilityOtherUsers.owner &&
                      ctr.job.idAssignedTo &&
                      ctr.job.idAssignedTo === ctr.currentAccount.id
                    ) {
                      ctr.canSeeAccount = true;
                    } else {
                      ctr.canSeeAccount = false;
                    }
                  } else {
                    ctr.canSeeAccount = true;
                  }
                  ctr.canSeeTicket = true;
                  ctr.canSeeContact = true;
                  ctr.isContact = false;
                  ctr.ticketName = '';
                  ctr.repeatEvery = '';
                  ctr.showTicket = showTicket;
                  ctr.isTasksPage = isTasksPage;
                  ctr.showRepeatOptions = ctr.isEditingJob && ctr.job.isRecurring;
                  ctr.completedInitialization = !ctr.isEditingJob;
                  ctr.timeIntervalAvailable = TimeUnit.Available;
                  ctr.stageJobTemplate = angular.copy(ctr.job);
                  ctr.mdMedia = mdMedia;

                  if (ctr.isJob && !ctr.isStageJob) {
                    ctr.getWorkflowsAvailable = () => {
                      ctr.isWorkflowReady = false;
                      workflowsService.getAvailable({ isActive: true }).then((workflows) => {
                        ctr.workflowsFiltered = _.filter(
                          workflows,
                          (w) => w.idTeamMembers.indexOf(ctr.job.idAssignedTo) >= 0
                        );
                        ctr.selectWorkflow(ctr.workflowsFiltered, ctr.job.idWorkflow);
                        ctr.isWorkflowReady = true;

                        if (ctr.workflowsFiltered.length === 1) {
                          ctr.job.idWorkflow = ctr.workflowsFiltered[0].id;
                          ctr.getTicketsAvailable(ctr.workflowsFiltered[0].id);
                        }
                        ctr.setAccounts(ctr.selectedWorkflow, ctr.accounts);
                      });
                    };

                    ctr.getTicketsAvailable = (idWorkflow) => {
                      ctr.isTicketReady = false;
                      ticketsService
                        .getByWorkflow({
                          idWorkflow,
                          fields: TICKET.FIELDS.BOARD,
                          idFilter: null
                        })
                        .then((tickets) => {
                          ctr.ticketsFiltered = tickets;
                          ctr.selectTicket(ctr.ticketsFiltered, ctr.job.idTicket);
                          ctr.isTicketReady = true;

                          if (ctr.ticketsFiltered.length === 1) {
                            ctr.job.idTicket = ctr.ticketsFiltered[0].id;
                            ctr.ticketName = ctr.ticketsFiltered[0].getName();
                            if (!_.isUuid(ctr.job.idAssignedTo)) {
                              if (ctr.selectedTicket && ctr.selectedTicket.idOwner) {
                                ctr.job.idAssignedTo = ctr.selectedTicket.idOwner;
                              }
                            }
                          }
                        });
                    };
                    if (
                      ctr.isTasksPage &&
                      !ctr.isEditingJob &&
                      ctr.ticketsFiltered.length &&
                      ctr.workflowsFiltered.length
                    ) {
                      ctr.getWorkflowsAvailable();
                    }

                    // Get Current Ticket
                    ctr.getTicket = (idTicket) =>
                      ctr.ticketsFiltered.find((t) => t.id === idTicket);

                    ctr.getCurrentTicket = (idTicket) => {
                      ticketService.readTicket({ id: idTicket }).then((result) => {
                        if (result) {
                          let isCheckedReady = false;
                          workflowService.readWorkflow({ id: result.idWorkflow }).then((wf) => {
                            if (
                              !ctr.currentAccount.isAdministrator &&
                              ctr.currentOrganization.permissions.visibilityDeals.team
                            ) {
                              isCheckedReady =
                                wf && wf.idTeamMembers.indexOf(ctr.currentAccount.id) > -1;
                            } else if (
                              !ctr.currentAccount.isAdministrator &&
                              ctr.currentOrganization.permissions.visibilityDeals.owner
                            ) {
                              isCheckedReady =
                                result.idOwner === ctr.currentAccount.id ||
                                (result.idTeamMembers &&
                                  result.idTeamMembers.indexOf(ctr.currentAccount.id) > -1);
                            } else {
                              isCheckedReady = true;
                            }
                            if (isCheckedReady) {
                              ctr.ticketsFiltered = [result];
                              ctr.selectTicket(ctr.ticketsFiltered, ctr.job.idTicket);
                            } else {
                              ctr.canSeeTicket = false;
                            }
                            $timeout(() => {
                              ctr.isTicketReady = true;
                            });
                          });
                        } else {
                          ctr.isTicketReady = true;
                        }
                      });
                    };

                    // Get Current Ticket
                    ctr.getContact = (idContact) =>
                      ctr.contactsFiltered.find((c) => c.id === idContact);

                    ctr.getCurrentContact = (idContact) =>
                      contactService.readContact({ id: idContact }).then((result) => {
                        if (result) {
                          let isCheckedReady = false;
                          if (
                            !ctr.currentAccount.isAdministrator &&
                            ctr.currentOrganization.permissions.visibilityContacts.owner
                          ) {
                            isCheckedReady = result.idOwner === ctr.currentAccount.id;
                          } else {
                            isCheckedReady = true;
                          }
                          if (isCheckedReady) {
                            ctr.contactsFiltered = [result];
                            ctr.selectContact(ctr.contactsFiltered, ctr.job.idContact);
                          } else {
                            ctr.canSeeContact = false;
                          }
                          $timeout(() => {
                            ctr.isContactReady = true;
                          });
                        } else {
                          ctr.isContactReady = true;
                        }
                      });

                    // Account actions
                    ctr.changeAssignedTo = () => {
                      ctr.setAccounts(ctr.selectedWorkflow, ctr.accounts);
                    };

                    ctr.setAccounts = (selectedWorkflow, acc) => {
                      if (selectedWorkflow) {
                        ctr.accountsFiltered = _.filter(
                          acc,
                          (a) => selectedWorkflow.idTeamMembers.indexOf(a.id) >= 0
                        );
                      } else {
                        ctr.accountsFiltered = acc;
                      }
                    };

                    ctr.isAssignedToSelected = (a) => {
                      let isCheckedReady = false;
                      if (ctr.isEditingJob) {
                        if (ctr.currentAccount.isAdministrator) {
                          isCheckedReady = true;
                        } else if (
                          !ctr.currentAccount.isAdministrator &&
                          (ctr.currentOrganization.permissions.visibilityOtherUsers.team ||
                            ctr.currentOrganization.permissions.visibilityOtherUsers
                              .organization)
                        ) {
                          isCheckedReady = true;
                        } else if (
                          !ctr.currentAccount.isAdministrator &&
                          ctr.currentOrganization.permissions.visibilityOtherUsers.owner &&
                          ctr.job.idAssignedTo &&
                          ctr.job.idAssignedTo === ctr.currentAccount.id
                        ) {
                          isCheckedReady = true;
                        }
                      } else {
                        isCheckedReady = true;
                      }
                      if (isCheckedReady) {
                        ctr.canSeeAccount = true;
                        return (
                          a && a.id && ctr.job.idAssignedTo && ctr.job.idAssignedTo === a.id
                        );
                      }
                      return false;
                    };

                    if (ctr.showAdditionalOptions) {
                      if (ctr.contactsFiltered.length === 1) {
                        ctr.job.idAssignedTo =
                          ctr.job.idAssignedTo || $rootScope.CurrentAccount.id;
                        ctr.job.idContact = ctr.contactsFiltered[0].id;
                        ctr.setAccounts(undefined, ctr.accounts);
                        ctr.isContactReady = true;
                      } else if (ctr.getContact(ctr.job.idContact) === undefined) {
                        ctr.getCurrentContact(ctr.job.idContact);
                      }
                      if (
                        ctr.ticketsFiltered.length === 1 &&
                        ctr.workflowsFiltered.length === 1
                      ) {
                        ctr.job.idAssignedTo =
                          ctr.job.idAssignedTo || $rootScope.CurrentAccount.id;
                        ctr.job.idWorkflow = ctr.workflowsFiltered[0].id;
                        ctr.isWorkflowReady = true;
                        ctr.job.idTicket = ctr.ticketsFiltered[0].id;
                        ctr.isTicketReady = true;
                      } else if (ctr.getTicket(ctr.job.idTicket) === undefined) {
                        ctr.getCurrentTicket(ctr.job.idTicket);
                      } else {
                        ctr.getTicketsAvailable(ctr.job.idWorkflow);
                      }
                    } else {
                      ctr.accountsFiltered = ctr.accounts;
                      if (!ctr.job.idAssignedTo) {
                        ctr.job.idAssignedTo = $rootScope.CurrentAccount.id;
                      }
                    }

                    // Toggle workflow and ticket options
                    ctr.toggleAdditionalOptions = () => {
                      ctr.showAdditionalOptions = !ctr.showAdditionalOptions;
                      if (ctr.showAdditionalOptions) {
                        ctr.toggleAdditionalInfo();
                      } else {
                        ctr.setAccounts(undefined, ctr.accounts);
                        ctr.job.idWorkflow = '';
                        ctr.workflowsFiltered = [];
                        ctr.job.idTicket = '';
                        ctr.ticketsFiltered = [];
                        ctr.job.idContact = '';
                        ctr.contactsFiltered = [];
                      }
                    };

                    ctr.toggleAdditionalInfo = () => {
                      if (ctr.isContact) {
                        ctr.job.idWorkflow = '';
                        ctr.workflowsFiltered = [];
                        ctr.job.idTicket = '';
                        ctr.ticketsFiltered = [];
                        ctr.setAccounts(undefined, ctr.accounts);
                        ctr.isContactReady = true;
                      } else {
                        ctr.job.idContact = '';
                        ctr.contactsFiltered = [];
                        ctr.isTicketReady = true;
                        ctr.getWorkflowsAvailable();
                      }
                    };

                    // Workflow actions
                    ctr.changeWorkflow = () => {
                      ctr.selectWorkflow(ctr.workflowsFiltered, ctr.job.idWorkflow);
                      ctr.setAccounts(ctr.selectedWorkflow, ctr.accounts);
                      ctr.getTicketsAvailable(ctr.selectedWorkflow.id);
                    };

                    ctr.selectWorkflow = (workflows, jobIdWorkflow) => {
                      ctr.selectedWorkflow = _.find(workflows, (w) => w.id === jobIdWorkflow);
                      if (!ctr.selectedWorkflow) {
                        ctr.job.idTicket = '';
                        ctr.ticketsFiltered = [];
                      }
                    };

                    ctr.isWorkflowSelected = (w) =>
                      w && w.id && ctr.job.idWorkflow && ctr.job.idWorkflow === w.id;

                    // Ticket actions
                    ctr.changeTicket = () => {
                      ctr.selectTicket(ctr.ticketsFiltered, ctr.job.idTicket);
                      if (ctr.selectedTicket && ctr.selectedTicket.idOwner) {
                        ctr.job.idAssignedTo = ctr.selectedTicket.idOwner;
                        ctr.changeAssignedTo();
                      }
                    };

                    ctr.selectTicket = (tickets, jobIdTicket) => {
                      ctr.selectedTicket = tickets.find((t) => t.id === jobIdTicket);
                    };

                    ctr.isTicketSelected = (t) =>
                      t && t.id && ctr.job.idTicket && ctr.job.idTicket === t.id;

                    ctr.ticketView = (idWorkflow, idTicket) => {
                      ctr.cancel();
                      $timeout(() => {
                        $state.transitionTo('deal', { id: idWorkflow, dd: idTicket });
                      });
                    };

                    // Contact
                    ctr.selectedContactItemChange = (selectedContactItem) => {
                      if (selectedContactItem && selectedContactItem.id) {
                        ctr.contact.id = selectedContactItem.id;
                        ctr.contact.name = selectedContactItem.name;
                        ctr.job.idContact = selectedContactItem.id;
                      }
                    };

                    ctr.searchContact = (query) => searchService.getContacts({ query });

                    ctr.selectContact = (contacts, jobIdContact) => {
                      ctr.selectedContact = _.find(contacts, (c) => c.id === jobIdContact);
                    };

                    ctr.contactView = (idContact) => {
                      const c = ctr.getContact(idContact);
                      if (c !== undefined) {
                        ctr.cancel();
                        $timeout(() => {
                          $state.transitionTo('contactView', {
                            type: c.isCompany ? 'company' : 'person',
                            id: c.id
                          });
                        });
                      }
                    };

                    ctr.completedAllSubItems = () => {
                      if (ctr.job.items && ctr.job.items.length) {
                        for (let s = 0; s < ctr.job.items.length; s += 1) {
                          ctr.job.items[s].isActive = true;
                        }
                      }
                    };

                    ctr.jobPinned = () => {
                      ctr.job.isPinned = !ctr.job.isPinned;
                    };

                    // Repeat options
                    ctr.toggleRepeatOptions = () => {
                      ctr.showRepeatOptions = !ctr.showRepeatOptions;
                      ctr.job.isRecurring = !ctr.job.isRecurring;
                      if (ctr.showRepeatOptions) {
                        ctr.job.repeat.duration.startDate = parseInt(
                          moment.utc().tz(ctr.currentTimeZone).startOf('day').format('X'),
                          10
                        );
                        ctr.getSetRepeatStartDate(
                          moment.utc(ctr.job.repeat.duration.startDate, 'X').toDate()
                        );
                        ctr.job.absoluteDueDate = ctr.job.repeat.duration.startDate;
                        ctr.changeAbsoluteDueDate();
                        ctr.setDayOfWeek();
                        ctr.getSummary();
                      } else {
                        ctr.job.absoluteDueDate = parseInt(
                          moment
                            .utc()
                            .tz(ctr.currentTimeZone)
                            .startOf('day')
                            .add(7, 'days')
                            .format('X'),
                          10
                        );
                        ctr.changeAbsoluteDueDate();
                        ctr.job.repeat = {
                          repeats: 2,
                          repeatEvery: 1,
                          repeatOn: [],
                          repeatBy: false,
                          duration: { startDate: 0, endOption: 1, occurrence: 0, endDate: 0 }
                        };
                      }
                    };

                    ctr.changeRepeats = () => {
                      ctr.job.repeat.repeatEvery = 1;
                      ctr.changeRepeatEvery();
                      ctr.setDayOfWeek();
                    };

                    ctr.changeRepeatEvery = () => {
                      const sD = moment.utc(ctr.job.repeat.duration.startDate, 'X');
                      const eD =
                        parseInt(ctr.job.repeat.duration.endDate || 0, 10) !== 0
                          ? parseInt(moment.utc(ctr.job.repeat.duration.endDate, 'X'), 10)
                          : 0;
                      const rE = ctr.job.repeat.repeatEvery;
                      let nD = 0;

                      switch (ctr.job.repeat.repeats) {
                        case 1:
                          ctr.job.repeat.repeatOn = [];
                          ctr.job.repeat.repeatBy = false;
                          nD = moment.utc(sD).add(rE, 'days');
                          break;
                        case 2:
                          if (ctr.completedInitialization) {
                            ctr.job.repeat.repeatBy = false;
                            ctr.job.repeat.repeatOn = ctr.job.repeat.repeatOn.length
                              ? ctr.job.repeat.repeatOn
                              : [].concat(sD.isoWeekday());
                            if (ctr.job.repeat.repeatOn.indexOf(sD.isoWeekday()) > -1) {
                              nD = sD;
                            } else {
                              const absoluteDueDate = (day) => {
                                if (day > 7) {
                                  return sD.add(rE * 7, 'days');
                                }
                                if (ctr.job.repeat.repeatOn.indexOf(day) > -1) {
                                  return sD.add(day - sD.isoWeekday() - 1, 'days');
                                }
                                return absoluteDueDate(day + 1);
                              };
                              nD = absoluteDueDate(sD.isoWeekday() + 1);
                            }
                          } else {
                            nD = moment.utc(job.absoluteDueDate, 'X');
                            ctr.setAbsoluteDate(nD, eD);
                            ctr.completedInitialization = true;
                          }
                          break;
                        case 3:
                          ctr.job.repeat.repeatOn = [];
                          if (!ctr.job.repeat.repeatBy) {
                            const absoluteDueDate = (addMonth) => {
                              const aM = addMonth + rE;
                              const date = moment.utc(sD).add(aM, 'months');
                              if (moment.utc(date).date() === sD.date()) {
                                return date;
                              }
                              return absoluteDueDate(aM);
                            };
                            nD = absoluteDueDate(0);
                          } else {
                            const nMD = moment.utc(sD).add(rE, 'months');
                            const sW = sD.week() - moment.utc(sD).startOf('month').week() + 1;
                            let s = null;
                            if (sW === 1) {
                              s = 1;
                            } else {
                              s = sW > 1 && sW < 5 ? sW : sW - 1;
                            }
                            nD = ctr.nthWeekdayOfMonth(sD.isoWeekday(), s, nMD.toDate());
                          }
                          break;
                        case 4:
                          ctr.job.repeat.repeatOn = [];
                          ctr.job.repeat.repeatBy = false;
                          nD = moment.utc(sD).add(rE, 'years');
                          break;
                        default:
                          break;
                      }
                      ctr.setAbsoluteDate(nD, eD);
                    };

                    ctr.setAbsoluteDate = (nextDate, endDate) => {
                      if (endDate !== 0) {
                        ctr.job.absoluteDueDate = moment(nextDate).isSameOrAfter(endDate)
                          ? endDate
                          : parseInt(moment.utc(nextDate).format('X') || 0, 10);
                      } else {
                        ctr.job.absoluteDueDate = parseInt(
                          moment.utc(nextDate).format('X') || 0,
                          10
                        );
                      }
                      dateTimeService.getSet(
                        ctrl,
                        ctrl.job,
                        'absoluteDueDate',
                        'getSetAbsoluteDate'
                      );
                      ctr.changeAbsoluteDueDate();
                    };

                    ctr.nthWeekdayOfMonth = (weekday, n, wDate) => {
                      const date = new Date(wDate.getFullYear(), wDate.getMonth(), 1);
                      const add = ((weekday - date.getDay() + 7) % 7) + (n - 1) * 7;
                      date.setDate(1 + add);
                      return date;
                    };

                    ctr.setDayOfWeek = () => {
                      const date = moment.utc();
                      const dow = date.isoWeekday();
                      ctr.job.repeat.repeatOn.push(dow);
                    };

                    ctr.changeEndOptions = () => {
                      switch (ctr.job.repeat.duration.endOption) {
                        case 1:
                          ctr.job.repeat.duration.occurrence = 0;
                          ctr.job.repeat.duration.endDate = 0;
                          break;
                        case 2:
                          ctr.job.repeat.duration.endDate = 0;
                          ctr.job.repeat.duration.occurrence = 5;
                          break;
                        case 3:
                          ctr.job.repeat.duration.endDate = parseInt(
                            moment
                              .utc(moment.utc(ctr.job.repeat.duration.startDate, 'X'))
                              .add(1, 'years')
                              .format('X') || 0,
                            10
                          );
                          ctr.getSetRepeatEndDate(
                            moment.utc(ctr.job.repeat.duration.endDate, 'X').toDate()
                          );
                          ctr.job.repeat.duration.occurrence = 0;
                          break;
                        default:
                          break;
                      }
                      ctr.changeRepeatEvery();
                    };

                    ctr.changeEndDate = () => {
                      if (
                        moment(moment.utc(ctr.job.repeat.duration.endDate, 'X')).isBefore(
                          moment.utc(ctr.job.repeat.duration.startDate, 'X')
                        )
                      ) {
                        const startDate = moment.utc(ctr.job.repeat.duration.startDate, 'X');
                        ctr.job.repeat.duration.endDate = moment
                          .utc(startDate)
                          .add(1, 'years')
                          .format('X');
                        ctr.job.getSetRepeatEndDate(
                          moment.utc(ctr.job.repeat.duration.endDate, 'X').toDate()
                        );
                      }
                      ctr.getSummary();
                      ctr.changeRepeatEvery();
                    };

                    ctr.getSummary = () => {
                      let summary = '';
                      let endSummary = '';
                      switch (ctr.job.repeat.repeats) {
                        case 1:
                          ctr.repeatEvery = ctr.job.repeat.repeatEvery === 1 ? 'Day' : 'Days';
                          if (ctr.getOccurrence() === 1) {
                            summary = 'Once';
                          } else {
                            summary =
                              ctr.job.repeat.repeatEvery === 1
                                ? 'Daily'
                                : `Every ${ctr.job.repeat.repeatEvery} days`;
                          }
                          break;
                        case 2:
                          ctr.repeatEvery = ctr.job.repeat.repeatEvery === 1 ? 'Week' : 'Weeks';
                          if (ctr.getOccurrence() === 1) {
                            summary = 'Once';
                          } else {
                            summary =
                              ctr.job.repeat.repeatEvery === 1
                                ? `Weekly on ${ctr.getSelectedDaysOfWeek()}`
                                : `Every ${
                                    ctr.job.repeat.repeatEvery
                                  } weeks on ${ctr.getSelectedDaysOfWeek()}`;
                          }
                          break;
                        case 3:
                          ctr.repeatEvery =
                            ctr.job.repeat.repeatEvery === 1 ? 'Month' : 'Months';
                          if (ctr.getOccurrence() === 1) {
                            summary = 'Once';
                          } else {
                            summary =
                              ctr.job.repeat.repeatEvery === 1
                                ? `Monthly on ${ctr.getSelectedRepeatBy()}`
                                : `Every ${
                                    ctr.job.repeat.repeatEvery
                                  } months on ${ctr.getSelectedRepeatBy()}`;
                          }
                          break;
                        case 4:
                          ctr.repeatEvery = ctr.job.repeat.repeatEvery === 1 ? 'Year' : 'Years';
                          if (ctr.getOccurrence() === 1) {
                            summary = 'Once';
                          } else {
                            summary =
                              ctr.job.repeat.repeatEvery === 1
                                ? `Annually on ${moment
                                    .utc(ctr.job.repeat.duration.startDate, 'X')
                                    .format('MMMM D')}`
                                : `Every ${ctr.job.repeat.repeatEvery} years on ${moment
                                    .utc(ctr.job.repeat.duration.endDate, 'X')
                                    .format('LL')}`;
                          }
                          break;
                        default:
                          break;
                      }
                      if (ctr.job.repeat.duration.endOption === 2) {
                        endSummary =
                          ctr.getOccurrence() === 1 ? '' : `, ${ctr.getOccurrence()} times`;
                      } else {
                        endSummary =
                          ctr.job.repeat.duration.endOption === 3
                            ? `, until ${moment
                                .utc(ctr.job.repeat.duration.endDate, 'X')
                                .format('LL')}`
                            : '';
                      }
                      return summary + endSummary;
                    };

                    ctr.getOccurrence = () => {
                      if (ctr.job.repeat.duration.occurrence <= 0) {
                        ctr.job.repeat.duration.occurrence =
                          ctr.job.repeat.duration.endOption === 2 ? 1 : 0;
                      }
                      return ctr.job.repeat.duration.occurrence;
                    };

                    ctr.getSelectedDaysOfWeek = () => {
                      let output = '';
                      const days = [];
                      const selDays = ctr.job.repeat.repeatOn.filter((day) =>
                        days.push(ctr.getDayName(day))
                      );
                      if (selDays.length) {
                        if (ctr.job.repeat.repeatOn.equals([1, 2, 3, 4, 5])) {
                          output = 'weekdays';
                        } else if (ctr.job.repeat.repeatOn.equals([1, 2, 3, 4, 5, 6, 7])) {
                          output = 'all days';
                        } else {
                          output = days.join(',').replace(/,/g, ', ');
                        }
                      }
                      return output;
                    };

                    ctr.getDayName = (id) =>
                      ctr.availableDaysOfTheWeek.find((day) => day.id === id).value;

                    ctr.getSelectedRepeatBy = () => {
                      const dayOfTheMonth = moment
                        .utc(ctr.job.repeat.duration.startDate, 'X')
                        .date();
                      const dayOfTheWeek = moment
                        .utc(ctr.job.repeat.duration.startDate, 'X')
                        .isoWeekday();
                      return ctr.job.repeat.repeatBy
                        ? ctr.weekOfMonth(
                            moment.utc(ctr.job.repeat.duration.startDate, 'X'),
                            dayOfTheWeek
                          )
                        : `day ${dayOfTheMonth}`;
                    };

                    ctr.weekOfMonth = (date, dayOfTheWeek) => {
                      let output = '';
                      const numberOfWeek =
                        moment
                          .duration(
                            moment.utc(date).endOf('month') - moment.utc(date).startOf('month')
                          )
                          .weeks() + 1;
                      switch (date.week() - moment.utc(date).startOf('month').week() + 1) {
                        case 1:
                          output = `the first ${ctr.getDayName(dayOfTheWeek)}`;
                          break;
                        case 2:
                          output = `the second ${ctr.getDayName(dayOfTheWeek)}`;
                          break;
                        case 3:
                          output = `the third ${ctr.getDayName(dayOfTheWeek)}`;
                          break;
                        case 4:
                          output =
                            (numberOfWeek === 4 ? 'the last ' : 'the fourth ') +
                            ctr.getDayName(dayOfTheWeek);
                          break;
                        case 5:
                          output =
                            (numberOfWeek === 5 ? 'the last ' : 'the fifth ') +
                            ctr.getDayName(dayOfTheWeek);
                          break;
                        case 6:
                          output = `the last ${ctr.getDayName(dayOfTheWeek)}`;
                          break;
                        default:
                          break;
                      }
                      return output;
                    };
                  } else if (!ctr.isJob && ctr.isStageJob) {
                    ctr.accountsFiltered = accounts;
                    ctr.isAssignedToSelected = (a) =>
                      a && a.id && ctr.job.idAssignedTo && ctr.job.idAssignedTo === a.id;
                    if (!ctr.job.idAssignedTo) {
                      ctr.job.idAssignedTo = null;
                    }
                    ctr.jobPinned = () => {
                      ctr.job.isPinned = !ctr.job.isPinned;
                    };

                    ctr.isRelativeIntervalSelected = (i) =>
                      ctr.job.relativeInterval.id === i.id;
                  }

                  // Search for Job Types
                  ctr.searchJobTypes = (query) =>
                    query ? ctr.jobTypes.filter(ctr.createFilterFor(query)) : [];

                  ctr.createFilterFor = (query) =>
                    function filterFn(j) {
                      return j.name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
                    };

                  ctr.searchTermChange = (searchTerm) => {
                    ctr.job.name = searchTerm;
                  };

                  ctr.selectedItemChange = (selectedItem) => {
                    if (selectedItem) {
                      ctr.job.name = selectedItem.name;
                      ctr.job.description = selectedItem.description;
                      ctr.job.items = selectedItem.items;
                      ctr.job.idLabels = selectedItem.idLabels ? selectedItem.idLabels : [];
                      ctr.job.jobTemplate = selectedItem?.id
                        ? {
                            id: selectedItem.id
                          }
                        : undefined;
                    }
                  };

                  // Add/Delete Sub-Tasks
                  ctr.addSubItem = () => {
                    ctr.job.items.push(JobItem.blank());
                  };

                  ctr.deleteSubItem = (index) => {
                    ctr.job.items.splice(index, 1);
                  };

                  ctr.isJobValid = () => {
                    if (ctr.isJob && !ctr.isStageJob) {
                      if (ctr.job.idWorkflow && !ctr.job.idContact) {
                        return (
                          ctr.job.name !== '' &&
                          ctr.job.idAssignedTo &&
                          ctr.job.absoluteDueDate !== 0 &&
                          ctr.job.idTicket !== ''
                        );
                      }
                      if (!ctr.job.idWorkflow && !ctr.job.idTicket) {
                        return (
                          ctr.job.name !== '' &&
                          ctr.job.idAssignedTo &&
                          ctr.job.absoluteDueDate !== 0 &&
                          ctr.job.idContact !== ''
                        );
                      }
                      return (
                        ctr.job.name !== '' &&
                        ctr.job.idAssignedTo &&
                        ctr.job.absoluteDueDate !== 0
                      );
                    }
                    if (!ctr.isJob && !ctr.isStageJob) {
                      return ctr.job.name !== '';
                    }
                    if (!ctr.isJob && ctr.isStageJob) {
                      return ctr.job.name !== '';
                    }
                    return true;
                  };

                  ctr.confirm = () => {
                    if (ctr.isJob && !ctr.isStageJob) {
                      if (ctr.isJobDescriptionChanged && ctr.isEditingJob) {
                        const now = moment.utc().tz(ctr.currentTimeZone).format('X');
                        const dateTimeStamp = dateTimeService.getFormattedDateTime(now);
                        ctr.job.description += '\r\n\r\n';
                        ctr.job.description += `Modified by ${$rootScope.CurrentAccount.getName()} on ${dateTimeStamp}`;
                      }

                      if (ctr.job.name !== '' && ctr.job.idAssignedTo) {
                        if (ctr.showAdditionalOptions) {
                          if (
                            (!ctr.job.idContact && ctr.job.idWorkflow && ctr.job.idTicket) ||
                            (ctr.job.idContact && !ctr.job.idWorkflow && !ctr.job.idTicket)
                          ) {
                            $mdDialog.hide({ job: ctr.job, isJob: true, isStageJob: false });
                          } else {
                            uiService.toast({
                              text: {
                                p1: 'Task',
                                p2: ctr.job.idContact !== '' ? 'Workflow and Deal' : 'Contact',
                                p3: ctr.job.idContact !== '' ? 'are required' : 'is required'
                              },
                              warn: true
                            });
                          }
                        } else {
                          $mdDialog.hide({ job: ctr.job, isJob: true, isStageJob: false });
                        }
                      } else {
                        uiService.toast({
                          text: {
                            p1: 'Task',
                            p2: 'name and assigned to',
                            p3: 'are required'
                          },
                          warn: true
                        });
                      }
                    } else if (!ctr.isJob && !ctr.isStageJob) {
                      if (ctr.job.name !== '') {
                        $mdDialog.hide({ job: ctr.job, isJob: false, isStageJob: false });
                      } else {
                        uiService.toast({
                          text: {
                            p1: 'Task Template',
                            p2: 'name',
                            p3: 'is required'
                          },
                          warn: true
                        });
                      }
                    } else if (!ctr.isJob && ctr.isStageJob) {
                      if (ctr.job.name !== '' && ctr.job.relativeDueDate) {
                        ctr.job.jobTemplate = !ctr.job.jobTemplate
                          ? ctr.stageJobTemplate
                          : undefined;
                        $mdDialog.hide({
                          job: ctr.job,
                          stage: ctr.stage,
                          isJob: false,
                          isStageJob: true
                        });
                      } else {
                        uiService.toast({
                          text: {
                            p1: 'Task Template',
                            p2: 'name and due date',
                            p3: 'are required'
                          },
                          warn: true
                        });
                      }
                    }
                  };
                  ctr.cancel = () => {
                    $mdDialog.cancel();
                  };
                }
              })
              .then((res) => {
                const result = res;
                if (result.isJob && !result.isStageJob) {
                  if (!_.isUuid(result.job.id)) {
                    result.job.jobProgress = result.job.isCompleted
                      ? JobProgress.of('done')
                      : JobProgress.of('to_do');
                    jobService.createJob(result.job).then((data) => {
                      if (data.status) {
                        result.job.id = data.id;
                        result.job.isNew = true;
                        ctrl.onFinished({ job: result.job });
                        uiService.toast({
                          text: {
                            p1: 'Task',
                            p2: result.job.getName(),
                            p3: 'has been added'
                          }
                        });
                      }
                    });
                  } else {
                    result.job.jobProgress = result.job.isCompleted
                      ? JobProgress.of('done')
                      : JobProgress.of('doing');
                    jobService.updateJob(result.job).then((data) => {
                      if (data.status) {
                        const job = data.job ? data.job : result.job;
                        if (data.job) {
                          job.isNew = true;
                        }
                        ctrl.onFinished({ job });
                        uiService.toast({
                          text: {
                            p1: 'Task',
                            p2: job.getName(),
                            p3: 'has been updated'
                          }
                        });
                      }
                    });
                    ctrl.job = result.job;
                  }
                } else if (!result.isJob && !result.isStageJob) {
                  if (!_.isUuid(result.job.id)) {
                    jobTypeService.createJobType(result.job).then((data) => {
                      if (data.status) {
                        result.job.id = data.id;
                        result.job.isNew = true;
                        ctrl.onFinished({ jobType: result.job });
                        uiService.toast({
                          text: {
                            p1: 'Task Template',
                            p2: result.job.getName(),
                            p3: 'has been added'
                          }
                        });
                      }
                    });
                  } else {
                    jobTypeService.updateJobType(result.job).then((data) => {
                      if (data.status) {
                        ctrl.onFinished({ jobType: result.job });
                        uiService.toast({
                          text: {
                            p1: 'Task Template',
                            p2: result.job.getName(),
                            p3: 'has been updated'
                          }
                        });
                      }
                    });
                    ctrl.job = result.job;
                  }
                } else if (!result.isJob && result.isStageJob) {
                  if (result.job.isNew) {
                    result.job.id = _.uuid();
                    ctrl.onFinished({ jobType: result.job, stage: result.stage });
                    uiService.toast({
                      text: {
                        p1: 'Task Template',
                        p2: result.job.getName(),
                        p3: 'has been added'
                      }
                    });
                  } else {
                    ctrl.job = result.job;
                    ctrl.onFinished({ jobType: result.job, stage: result.stage });
                    uiService.toast({
                      text: {
                        p1: 'Task Template',
                        p2: result.job.getName(),
                        p3: 'has been updated'
                      }
                    });
                  }
                }
              });
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
